import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { deriveCache, memo } from "../util/index.mjs";
var CACHE_KEY = 'eraPrefs';

function mapPrefs(era, all) {
  var validators = {};
  all.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        prefs = _ref2[1];

    validators[key.args[1].toString()] = prefs;
  });
  return {
    era: era,
    validators: validators
  };
}

export function _eraPrefs(instanceId, api) {
  return memo(instanceId, function (era, withActive) {
    var cacheKey = "".concat(CACHE_KEY, "-").concat(era.toString());
    var cached = withActive ? undefined : deriveCache.get(cacheKey);
    return cached ? of(cached) : api.query.staking.erasValidatorPrefs.entries(era).pipe(map(function (prefs) {
      var value = mapPrefs(era, prefs);
      !withActive && deriveCache.set(cacheKey, value);
      return value;
    }));
  });
}
export function eraPrefs(instanceId, api) {
  return memo(instanceId, function (era) {
    return api.derive.staking._eraPrefs(era, true);
  });
}
export function _erasPrefs(instanceId, api) {
  return memo(instanceId, function (eras, withActive) {
    return eras.length ? combineLatest(eras.map(function (era) {
      return api.derive.staking._eraPrefs(era, withActive);
    })) : of([]);
  });
}
export function erasPrefs(instanceId, api) {
  return memo(instanceId, function () {
    var withActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return api.derive.staking.erasHistoric(withActive).pipe(switchMap(function (eras) {
      return api.derive.staking._erasPrefs(eras, withActive);
    }));
  });
}